import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-6 md:py-10 px-6" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-111">
          <div className="flex justify-center mb-4" data-id="element-112">
            <SparklesIcon className="w-12 h-12 text-gold" strokeWidth={1.5} data-id="element-113" />
          </div>

          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-6 text-center" data-id="element-114">
            Lo Que Cambia en 7 Días
          </h2>

          <div className="bg-gradient-to-br from-cream to-white rounded-3xl p-5 md:p-8 border-2 border-gold/20 shadow-lg" data-id="element-115">
            <p className="font-sans text-lg md:text-xl text-brown/90 leading-relaxed mb-3" data-id="element-116">
              No prometemos un positivo inmediato, pero prometemos un cambio de
              frecuencia.
            </p>

            <div className="space-y-2 mb-3" data-id="element-117">
              <p className="font-sans text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-118">
                ✨ En la primera semana, el peso en tus hombros desaparece.
              </p>
              <p className="font-sans text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-119">
                ✨ La relación con tu madre se suaviza.
              </p>
              <p className="font-sans text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-120">
                ✨ El miedo constante se transforma en una certeza tranquila.
              </p>
            </div>

            <p className="font-sans text-lg md:text-xl text-brown font-semibold leading-relaxed text-center" data-id="element-121">
              Dejas de "buscar" un hijo con desesperación para empezar a
              "esperarlo" con orden.
            </p>

            <div className="mt-5 pt-4 border-t border-gold/20 text-center" data-id="element-122">
              <p className="font-sans text-base text-brown/70 mb-2" data-id="element-123">
                Accede hoy al sistema completo por solo:
              </p>
              <div className="flex items-center justify-center gap-3 mb-3" data-id="element-124">
                <span className="font-serif text-2xl text-brown/40 line-through" data-id="element-125">
                  $27
                </span>
                <span className="font-serif text-4xl md:text-5xl font-bold text-rose" data-id="element-126">
                  $6.36
                </span>
                <span className="font-sans text-sm text-brown/60" data-id="element-127">USD</span>
              </div>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={() => {
              trackAddToCart();
              window.open('https://www.inerciacero.com/cart/42837827551335:1', '_blank');
            }} className="bg-rose text-white font-sans font-semibold text-lg px-12 py-5 rounded-full shadow-lg hover:bg-rose/90 transition-colors cursor-pointer" data-id="element-128">
                Quiero Sanar Mi Linaje y Recibir a Mi Hijo
              </motion.button>
              <p className="font-sans text-sm text-brown/60 mt-3" data-id="element-129">
                Acceso inmediato y discreto para comenzar esta misma noche.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}